
import React, { useEffect, useRef, useState } from "react";
import config from "../config";

let autoComplete;

const loadScript = (url, callback) => {
  const script = document.createElement("script");
  script.type = "text/javascript";

  if (script.readyState) {
    script.onreadystatechange = function () {
      if (script.readyState === "loaded" || script.readyState === "complete") {
        script.onreadystatechange = null;
        callback();
      }
    };
  } else {
    script.onload = () => callback();
  }

  script.src = url;
  document.getElementsByTagName("head")[0].appendChild(script);
};

const SearchLocationInput = ({ setSelectedLocation, query, setQuery }) => {
  const autoCompleteRef = useRef(null);

  const handleScriptLoad = (updateQuery, autoCompleteRef) => {
    autoComplete = new window.google.maps.places.Autocomplete(autoCompleteRef.current, {
      componentRestrictions: { country: "IN" },
      fields: ["address_components", "geometry", "formatted_address"],
    });

    autoComplete.addListener("place_changed", () => {
      handlePlaceSelect(updateQuery);
    });
  };

  const handlePlaceSelect = async (updateQuery) => {
    const place = autoComplete.getPlace();
    if (!place.geometry) {
      console.error("No geometry found for place");
      return;
    }
    const query = place.formatted_address;
    updateQuery(query);

    const latLng = {
      lat: place.geometry.location.lat(),
      lng: place.geometry.location.lng(),
    };

    const addressDetails = {
      address: query,
      city: place.address_components.find((c) => c.types.includes("locality"))?.long_name || "",
      state: place.address_components.find((c) => c.types.includes("administrative_area_level_1"))?.long_name || "",
      postalCode: place.address_components.find((c) => c.types.includes("postal_code"))?.long_name || "",
      country: place.address_components.find((c) => c.types.includes("country"))?.long_name || "",
    };

    setSelectedLocation(latLng, addressDetails);
  };

  useEffect(() => {
    loadScript(
      `https://maps.googleapis.com/maps/api/js?key=${config.REACT_APP_GOOGLE_MAPS_KEY}&libraries=places`,
      () => handleScriptLoad(setQuery, autoCompleteRef)
    );
  }, [setQuery]);

  return (
    <div className="search-location-input">
      <input
        ref={autoCompleteRef}
        className="form-control"
        onChange={(event) => setQuery(event.target.value)}
        placeholder="Search Places ..."
        value={query}
      />
    </div>
  );
};

export default SearchLocationInput;

